import {getGuest} from '../api/getGuest'
import {validateGuest} from "../model/validateGuest";
import {useEffect, useState} from "react";

enum MODAL_CONTENT {
  FILL_UP_PERSONAL_INFO = 'fillUpPersonalInfo'
}

export const useMeasureFlowFeature = ({ lineUserId }) => {
  const [dialogContent, setDialogContent] = useState<MODAL_CONTENT | ''>('');
  const [guest, setGuest] = useState(null);
  const [isGuestValid, setIsGuestValid] = useState(false);

  const fetch = async () => {
    try {
      const tempGuest = await getGuest({lineId: lineUserId })
      const guestValid = validateGuest(tempGuest)
      setIsGuestValid(guestValid)
      setGuest(tempGuest)
      if (!guestValid){
        handleShowPersonalInfoForm();
      }
    } catch (error) {
      console.error(error)
    } finally {
    }
  }

  useEffect(() => {
    if (lineUserId) {
      fetch();
    }
  }, [lineUserId]);

  const handleShowPersonalInfoForm = () => setDialogContent(MODAL_CONTENT.FILL_UP_PERSONAL_INFO)
  const handleCloseModal = () => setDialogContent('')

  return { dialogContent, guest, isGuestValid, fetch, handleShowPersonalInfoForm, handleCloseModal }
}